/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

// ----- Types

export type LayoutModel = {
  items: Array<Object>;
  settings: LayoutSettings;
};

export type LayoutSettings = {
  margin: Array<Number>;
  columns: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  itemsPerRow: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  rowHeight: Number;
  showPosition: Boolean;
  titleField: String;
  verticalCompact: Boolean;
  useCssTransforms: Boolean;
  isResizable: Boolean;
  isDraggable: Boolean;
  allowNewItems: Boolean;
};

export type GridItemType = {
  i: String;
  x: Number;
  y: Number;
  w: Number;
  h: Number;
  item?: Object;
  minW?: Number;
  minH?: Number;
  maxW?: Number;
  maxH?: Number;
  isResizable?: Boolean;
  isDraggable?: Boolean;
  isReadonly?: Boolean;
  title?: String;
  componentType?: String;
};

export enum ComponentTypes {
  default = 'DefaultItem',
  section = 'SectionItem',
}

// ----- Defaults

export const DEFAULT_LAYOUT_SETTINGS = {
  margin: [20, 20],
  columns: 12, // this should be up to 12
  itemsPerRow: 4, // columns % itemsPerRow should be 0
  rowHeight: 40,
  showPosition: true,
  verticalCompact: false,
  useCssTransforms: true,
  isResizable: true,
  isDraggable: true,
};

export const DEFAULT_GRID_ITEMS_SETTINGS = {
  [ComponentTypes.default]: {
    component: ComponentTypes.default,
    title: 'New Default Item',
    x: 0,
    y: 0,
    h: 1,
    w: 1,
    isResizable: true,
  },
  [ComponentTypes.section]: {
    component: ComponentTypes.section,
    title: 'New Section',
    x: 0,
    y: 0,
    h: 1,
    w: 1,
    isResizable: false,
    isDraggable: true,
  },
};

export function getRequiredConfig(id) {
  return {
    i: id,
    x: null,
    y: null,
    w: null,
    h: null,
    minH: 1,
  };
}

export function getDefaultPosition() {
  return {
    x: 0,
    y: 0,
    w: 1,
    h: 1,
  };
}
